module Eseebase {
    export interface IMultiselectScope extends ng.IScope {
        model: any[];
        collection: any;
        valueMember: any;
        textMember: any;
        onOpen: Function;
        updateModel: Function;
        getElementsBetween: Function;
        onChanged: Function;
        onValueChanged: Function;
        freeText: string;
        oldModel: any[];
        sortBy: string;
        descending: string;
        ngDisabled: boolean;
    }

    export class MultiselectDirective {
        public link: (scope: IMultiselectScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/multiselect.html';
        public scope = {
            model: '=',
            collection: '=',
            valueMember: '=',
            textMember: '=',
            sortBy: '=',
            descending: '=',
            ngDisabled: '=',
            onChanged: '&'
        };
        public restrict = 'E';
        public replace: any;

        constructor(private $http: ng.IHttpService, private $mdDialog: any, private $timeout: ng.ITimeoutService, private $filter: any)
        {
            var vm = this;
            MultiselectDirective.prototype.restrict = 'E';
            MultiselectDirective.prototype.replace = 'true';
            MultiselectDirective.prototype.scope = { model: '@', collection: '=', valueMember: '=', textMember: '=', onChanged: '&', sortBy: '=', descending: '=', ngDisabled: '='};
            MultiselectDirective.prototype.link = (scope: IMultiselectScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {

                scope.collection = $filter('orderBy')(scope.collection, scope.sortBy, scope.descending);
                scope.$watch((sc) => scope.collection, () => {
                    if (scope.collection == null || scope.collection.length == 0) {
                        return;
                    }
                    var newCollection = [];
                    if (scope.valueMember != '') {
                        for (var item of scope.collection) {
                            if (newCollection.filter(f => f[scope.valueMember] == item[scope.valueMember]).length == 0) {
                                newCollection.push(item);
                            }
                        }
                    }
                    else {
                        for (var item of scope.collection) {
                            if (newCollection.indexOf(item) == -1) {
                                newCollection.push(item);
                            }
                        }
                    }
                    if (scope.sortBy != null && scope.sortBy != '') {
                        scope.collection = $filter('orderBy')(newCollection, scope.sortBy, scope.descending);
                    }
                    else {
                        scope.collection = newCollection;
                    }
                }, true);
                element.on('mousedown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.cancelBubble = true;
                    return false;
                });
                element.on('mouseup', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.cancelBubble = true;
                    return false;
                });
                element.on('click', function (e) {
                    //e.preventDefault();
                    //e.stopPropagation();
                    //e.stopImmediatePropagation();
                    //e.cancelBubble = true;
                    //return false;
                });

                scope.onOpen = function (e) {
                    var posX = e.pageX - $(element).offset().left,
                        posY = e.pageY - $(element).offset().top,
                        fieldWidth = $(element).width(),
                        openerWidth = $(element).find('.md-select-icon').width();

                    scope.oldModel = scope.model;
                    if (scope.collection != null && scope.collection.length > 0 && posX < fieldWidth - openerWidth) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        $(element).find('.md-select-value').hide();
                        var input = $('<input class="md-title ng-pristine md-input" style="margin:0;padding:0;border:0;"/>');
                        var inputContainer = $('<md-input-container class="md-icon-float" style="margin:0;padding:0;border:0;"></md-input-container>');
                        inputContainer.append(input).insertAfter($(element));
                        if ((scope.freeText == null || scope.freeText == '') && scope.model != null) {
                            scope.freeText = scope.model.join();;
                        }
                        input.val(scope.freeText);
                        input.focus();
                        input.on('blur', function (ev) {
                            vm.$timeout(() => {
                                scope.freeText = scope.updateModel(input.val());
                                inputContainer.remove();
                                $(element).find('.md-select-value').show();
                            });
                        });
                        input.on('click', function (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                            ev.stopImmediatePropagation();
                        });
                        return false;
                    }
                    return true;
                }

                scope.updateModel = function (freeText: string) {
                    var oldModel = scope.model;
                    var newModel = [];
                    try {
                        var split = freeText.split(',');
                        for (var i = 0; i < split.length; i++) {
                            if (split[i].indexOf('-') > -1) {
                                var fromTo = split[i].split('-');
                                newModel = newModel.concat(scope.getElementsBetween(parseInt(fromTo[0]), parseInt(fromTo[1])));
                            }
                            else {
                                newModel = newModel.concat(scope.getElementsBetween(parseInt(split[i]), parseInt(split[i])));
                            }
                        }
                    }
                    catch (ex) {
                        freeText = '';
                        newModel = oldModel;
                    }
                    vm.$timeout(() => {
                        scope.model = newModel;
                        if (!vm.compareArrays(oldModel, newModel)) {
                            scope.onChanged();
                        }
                    });
                    return freeText;
                }

                scope.getElementsBetween = function (from: number, to: number) {
                    var result = [];
                    for (var i = 0; i < scope.collection.length; i++) {
                        var val = scope.valueMember != '' ? scope.collection[i][scope.valueMember] : scope.collection[i];
                        var parsed = parseInt(val);
                        if (parsed >= from && parsed <= to) {
                            result.push(val);
                        }
                    }
                    return result;
                }

                scope.onValueChanged = function () {
                    if (scope.model != null) {
                        scope.freeText = scope.model.join();
                    }
                    if (!vm.compareArrays(scope.oldModel, scope.model)) {
                        scope.onChanged();
                    }
                }
            };
        }

        private compareArrays(array1: string[], array2: string[]) {
            if (array1 == null || array2 == null || array1.length != array2.length) {
                return false;
            }
            for (var i = 0; i < array1.length; i++){
                if (array1[i] != array2[i]) {
                    return false;
                }
            }
            return true;
        }


        public static Factory() {
            var directive = ($http: ng.IHttpService, $mdDialog: any, $timeout: ng.ITimeoutService, $filter: any) => {
                return new MultiselectDirective($http, $mdDialog, $timeout, $filter);
            };

            directive['$inject'] = ['$http', '$mdDialog', '$timeout', '$filter'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('multiSelect', MultiselectDirective.Factory());
}